import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-success text-white fs-4 rounded p-2 text-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-body-tertiary" }, "Current Group: ", -1)
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "dialog-footer" }

import { ref, onMounted, reactive } from "vue";
import AccountService from "../../services/AccountService";
import { type FormRules, FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeGroupForm',
  setup(__props, { expose: __expose }) {

const isLoading = ref(false);
const ruleFormRef = ref<FormInstance>();
const showGroup = ref(false);
const currentGroup = ref("");
const formData = ref({
  id: 0,
  groupName: "",
});

const formRules = reactive<FormRules>({
  groupName: [
    { required: true, message: "Please input new group name", trigger: "blur" },
  ],
});

const show = (_id: number, _group: string) => {
  showGroup.value = true;
  currentGroup.value = _group;
  formData.value.id = _id;
};

const updateGroup = async () => {
  if (!ruleFormRef.value) return;
  isLoading.value = true;
  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) {
    isLoading.value = false;
    return;
  } else {
    try {
      await AccountService.updateGroupName(formData.value.id, formData.value);
      MsgPrompt.success("success", "Update group successfully");
      showGroup.value = false;
      formData.value.groupName = "";
    } catch (e) {
      const apiErrorMessage = e.response?.data?.message; // Adjust this path as needed
      const errorMessage = apiErrorMessage || "Update group failed";
      MsgPrompt.error("error", errorMessage);
      formData.value.groupName = "";
      console.log(e);
    }
  }

  isLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: showGroup.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showGroup).value = $event)),
    title: "Change IB Group",
    width: "500",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showGroup.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (updateGroup())),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(currentGroup.value), 1)
      ]),
      _createVNode(_component_el_form, {
        class: "mt-8",
        rules: formRules,
        model: formData.value,
        ref_key: "ruleFormRef",
        ref: ruleFormRef
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { prop: "groupName" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.groupName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.groupName) = $event)),
                class: "w-200px",
                placeholder: "Please input new group name"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})